import {useParams} from "react-router-dom";
import React, {useState} from "react";

// global components
import {NAVIGATION_BAR_HEIGHT} from "../../../../designSystem/tokens/spacing";
import {Divider} from "../../../../designSystem/components/Divider";
import {Dialog} from "../../../../designSystem/components/Dialog";

// shared components
import {FormPageLayout} from "../../../../components/layout/FormPageLayout";
import {ShortAnswer} from "../../../../components/ShortAnswer";
import {MNASF} from "../../../../widgets/ApplicationDetail/components/MNASF";
import {NextStepButton} from "../../../../widgets/NextStepButton";

import {NotQualifyDialog} from "../NotQualifyDialog";
import {ApplicationFormTitle} from "../ApplicationFormTitle";

import {useNewApplicationStep1} from "../../hooks/useNewApplicationStep1";
import {MODAL_CONTENT} from "../../model/modalContent";
import {generateDefaultFormData} from "../../model/generateDefaultFormData";
import {CheckboxForm} from "../CheckboxForm";

export const NewApplicationStep1Feature = () => {
  const {category} = useParams();
  const [formData, setFormData] = useState(generateDefaultFormData(category))

  const { dialogContent, checkboxes, submit, onConfirm } = useNewApplicationStep1({ category, formData })
  return (
    <React.Fragment>
      <FormPageLayout
        height={NAVIGATION_BAR_HEIGHT.LARGE}
        body={
          <div className="flex flex-col gap-4 p-6">
            <ApplicationFormTitle category={category} />

            <Divider />

            <CheckboxForm
              checkboxes={checkboxes}
              formData={formData}
              onChange={(value) => setFormData(value)}
            />

            {category === 'mobilePharmacist' && (
              <ShortAnswer
                type="text"
                label="請詳述原因"
                value={formData.reasonMobilePharmacist}
                onChange={(e) => {
                  setFormData({ ...formData, reasonMobilePharmacist: e.target.value })
                }}
              />
            )}

            {category === 'mobileDietitian' && (
              <MNASF
                onChangeAnswer={(score, ans) => {
                  setFormData({
                    ...formData,
                    MNASFScore: score,
                    MNASFAnswer: ans,
                  })
                }}/>
            )}
          </div>
        }
        footer={<NextStepButton onClick={submit} />}
      />
      <Dialog isOpen={dialogContent !== ''}>
        {dialogContent === MODAL_CONTENT.NOT_QUALIFIED ? (
          <NotQualifyDialog disQualifyReason="" onClick={onConfirm} />
        ) : null}
      </Dialog>
    </React.Fragment>
  )
}